import { create, StateCreator, StoreApi, UseBoundStore } from "zustand";
import { devtools } from "zustand/middleware";
import {
  ICorruptedGcp,
  IGCPRequestV2,
  ISuggestedGcp,
  SuggestedGcpType,
} from "../../apiFacades/bapi/gcpRequests";
import { ISite } from "../../apiFacades/csu/site";

interface ICurrentGCPRequestState {
  GCPRequest?: IGCPRequestV2;

  suggestedGcpsNames: Record<string, string>;

  site?: ISite;
}

interface ICurrentGCPRequestActions {
  setGCPRequest: (GCPRequest: IGCPRequestV2) => void;

  setSite: (site: ISite) => void;

  getSuggestedGcpById: (id: string) => ISuggestedGcp | undefined;

  getCorruptionById: (id: string) => ICorruptedGcp | undefined;
}

const initialState: ICurrentGCPRequestState = {
  GCPRequest: undefined,

  suggestedGcpsNames: {},

  site: undefined,
};

type StoreType = ICurrentGCPRequestState & ICurrentGCPRequestActions;

const store: StateCreator<StoreType> = (set, get) => ({
  ...initialState,

  setGCPRequest: (GCPRequest: IGCPRequestV2) => {
    if (GCPRequest?.suggested) {
      const suggestedTypeAddNew = GCPRequest.suggested.filter(
        (point) => point.type === SuggestedGcpType.ADD_NEW,
      );
      const suggestedTypeSendCoordinates = GCPRequest.suggested.filter(
        (point) => point.type === SuggestedGcpType.SEND_COORDINATES,
      );

      suggestedTypeAddNew.forEach((point, i) => {
        get().suggestedGcpsNames[point.id] = makeRequestedGcpName(
          point.type,
          i,
        );
      });

      suggestedTypeSendCoordinates.forEach((point, i) => {
        get().suggestedGcpsNames[point.id] = makeRequestedGcpName(
          point.type,
          i,
        );
      });
    }

    set({ GCPRequest });
  },

  setSite: (site: ISite) => set({ site }),

  getSuggestedGcpById: (id: string) => {
    const { GCPRequest } = get();

    if (!GCPRequest?.suggested) {
      return undefined;
    }

    return GCPRequest.suggested.find((point) => point.id === id);
  },
  getCorruptionById: (id: string) => {
    const { GCPRequest } = get();

    if (!GCPRequest?.corrupted) {
      return undefined;
    }
    return GCPRequest.corrupted.find((entry) => entry.flightMarkerId === id);
  },
});

// Have to cast type to ensure it works with redux dev tools
const currentGcpRequestStore = create<StoreType>(
  // @ts-ignore
  devtools(store, { name: "CurrentGcpRequestStore" }),
);

export type ICurrentGCPRequestStore = UseBoundStore<StoreApi<StoreType>>;

export default currentGcpRequestStore as ICurrentGCPRequestStore;

const makeRequestedGcpName = (type: ISuggestedGcp["type"], index: number) =>
  type === SuggestedGcpType.ADD_NEW
    ? `Requested_${index + 1}`
    : `SendCoordinates_${index + 1}`;
